import React, { cloneElement, useState } from 'react';
import { bool, func, node, number, object, string } from 'prop-types';
import classnames from 'classnames';
import { Connector, Step } from './Stepper';

const WorkFlow = ({ activeStep, children, containerStyle, ignoreContent, ignoreHide, onStepClickListener, type }) => {
  const [stepIndex, setStepIndex] = useState(activeStep || 0);

  const onStepLabelClick = index => () => !!onStepClickListener && onStepClickListener(index);

  const handleNext = () => {
    children[stepIndex].props?.onSubmit?.();
    setStepIndex(idx => idx + 1);
  };

  const handlePrev = () => {
    children[stepIndex].props?.onCancel?.();
    if (stepIndex > 0) setStepIndex(idx => idx - 1);
  };

  return (
    <div style={containerStyle}>
      <div
        className={classnames('stepper', {
          'd-sm-h d-md-b': !ignoreHide
        })}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', placeContent: 'center space-between' }}>
          {React.Children.map(children, ({ props: { label } }, i) => (
            <>
              <Step activeStep={activeStep || stepIndex} index={i} onClick={onStepLabelClick}>
                {label}
              </Step>
              {i < children.length - 1 && <Connector />}
            </>
          ))}
        </div>
      </div>
      {!ignoreContent &&
        stepIndex < children.length &&
        cloneElement(children[stepIndex].props.content, {
          type,
          handleNext,
          handlePrev
        })}
    </div>
  );
};

WorkFlow.propTypes = {
  activeStep: number,
  children: node.isRequired,
  type: string,
  ignoreHide: bool,
  ignoreContent: bool,
  containerStyle: object,
  onStepClickListener: func
};

WorkFlow.defaultProps = {
  activeStep: null,
  type: null,
  ignoreHide: false,
  ignoreContent: false,
  containerStyle: {},
  onStepClickListener: null
};

export default WorkFlow;
